import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  postalText: {
    color: theme.palette.grey.dark,
    fontSize: '12px',
    margin: theme.spacing(0, 0, .5),
    fontWeight: 600
  }
}));

export default useStyles;
